// Create a Jest file to test the DynamicCard component.
// The DynamicCard component is a functional component that renders a card.

// Path: packages/shared/src/components/Cards/Types/__tests__/DynamicCard.test.tsx

import React from 'react'
import { render, screen } from '@testing-library/react'
import DynamicCard from '../DynamicCard'
import {
  MiniCardProps,
  ImageCardProps,
  BadgeCardProps,
  FeaturedProps,
  BasicCardProps,
  PricingCardProps,
  RestaurantCardProps,
  InformationCardProps
} from '../types.d'

const PricingCardProp: PricingCardProps = {
  accentColor: 'blue-75',
  accentPosition: 'bottom',
  badgeColor: 'bg-lavender-0',
  badgeText: 'top',
  children: [
    {
      heading: 'heading',
      description: 'description',
      listStyles: 'list-plus-circle-gray',
      listItems: [
        {
          heading: 'Lorem ipsum',
          description: 'Lorem ipsum dolor sit amet',
          displayIcon: ''
        },
        {
          heading: 'Lorem ipsum',
          description: 'Lorem ipsum dolor sit amet',
          displayIcon: ''
        },
        {
          heading: 'Lorem ipsum',
          description: 'Lorem ipsum dolor sit amet',
          displayIcon: ''
        }
      ]
    }
  ],
  ctaLabel: 'Get a Demo',
  ctaLink: '/',
  packagePrice: '$100',
  packagePriceMonthly: '/month',
  padding: '24',
  pricePrefix: 'As low as',
  priceSuffix: '2.99%',
  sectionHeading: 'Heading',
  sectionDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  textAlignment: 'left'
}

const InformationProp: InformationCardProps = {
  ctaLabel: 'CTA Label',
  ctaLink: '#CTA-Link',
  children: [
    { heading: 'Lorem ipsum dolor sit amet', description: '', displayIcon: '' },
    { heading: 'Lorem ipsum dolor sit amet', description: '', displayIcon: '' },
    { heading: 'Lorem ipsum dolor sit amet', description: '', displayIcon: '' }
  ],
  icon: [
    {
      url: 'https://d2w1ef2ao9g8r9.cloudfront.net/images/icons/utility/thumbs-up.svg'
    }
  ],
  linkIcons: '',
  listStyles: 'list-checkmark-orange',
  paddingMatrix: [
    {
      paddingTop: '24',
      paddingRight: 'null',
      paddingBottom: 'null',
      paddingLeft: '24',
      mobileTop: '16',
      mobileRight: '24',
      mobileBottom: 'null',
      mobileLeft: '16'
    }
  ],
  sectionDescription: '',
  sectionHeading: 'Heading',
  subtitle: '',
  textAlignment: 'left'
}

const BadgeCardProp: BadgeCardProps = {
  images: {
    imageResolutions: [
      {
        desktop: [
          {
            exension: 'png',
            url: 'https://d2w1ef2ao9g8r9.cloudfront.net/images/demo@2x.png',
            title: 'demo',
            optimizedImages: {
              srcAvif:
                'https://d2w1ef2ao9g8r9.cloudfront.net/images/_1600x1575_crop_center-center_82_line/demo@2x.png.webp'
            }
          }
        ],
        tablet: [],
        mobile: []
      }
    ]
  },
  heading: 'Heading',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pulvinar ante. Etiam vel lacus ut mauris sodales pharetra.'
}

const FeaturedProp: FeaturedProps = {
  heading: 'Heading',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  backgroundColor: 'bg-white',
  badgeColor: 'bg-lavender-0',
  badgeText: 'top',
  borderColor: 'dark',
  elevation: 'floating',
  padding: {
    paddingTop: '24',
    paddingRight: 'null',
    paddingBottom: 'null',
    paddingLeft: '24',
    mobileTop: '16',
    mobileRight: '24',
    mobileBottom: 'null',
    mobileLeft: '16'
  },
  listItems: [
    { heading: 'Lorem ipsum dolor sit amet', description: '', displayIcon: '' },
    { heading: 'Lorem ipsum dolor sit amet', description: '', displayIcon: '' },
    { heading: 'Lorem ipsum dolor sit amet', description: '', displayIcon: '' }
  ],
  textAlignment: 'center',
  button: {
    label: 'CTA Label',
    link: '#CTA-Link',
    size: 'large',
    variation: 'primary'
  }
}

const BasicCardProp: BasicCardProps = {
  cardBorderColor: 'null',
  ctaLabel: 'Link Label',
  ctaLink: '#testLink',
  icon: [
    {
      url: 'https://d2w1ef2ao9g8r9.cloudfront.net/images/icons/display/other/restaurant-exterior.svg'
    }
  ],
  linkIcons: 'link--arrow-right',
  paddingMatrix: [
    {
      paddingTop: '24',
      paddingRight: 'null',
      paddingBottom: 'null',
      paddingLeft: '24',
      mobileTop: '16',
      mobileRight: '24',
      mobileBottom: 'null',
      mobileLeft: '16'
    }
  ],
  sectionDescription: {
    raw: JSON.stringify({
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pulvinar ante. Etiam vel lacus ut mauris sodales pharetra.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    })
  },
  sectionHeading: 'Heading',
  subtitle: 'SubHeading',
  textAlignment: 'center',
  toggleSwitch: false
}

const RestaurantCardProp: RestaurantCardProps = {
  ctaLabel: 'Test CTA Label',
  ctaLink: 'https://www.toasttab.com',
  description: 'Test Description',
  heading: 'Test Title',
  padding: '24'
}

const ImageCardProp: ImageCardProps = {
  ctaLabel: 'Link Label',
  ctaLink: '#testLink',
  image: [
    {
      extension: 'png',
      url: 'https://d2w1ef2ao9g8r9.cloudfront.net/images/demo@2x.png',
      title: 'demo',
      optimizedImages: {
        srcAvif:
          'https://d2w1ef2ao9g8r9.cloudfront.net/images/_1600x1575_crop_center-center_82_line/demo@2x.png.webp'
      }
    }
  ],
  linkIcons: 'arrow',
  padding: '24',
  sectionDescription:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pulvinar ante. Etiam vel lacus ut mauris sodales pharetra.',
  sectionHeading: 'Heading',
  textAlignment: 'center'
}

const MiniCardProp: MiniCardProps = {
  borderColor: 'dark',
  description: 'Description',
  elevation: 'raised',
  heading: 'Heading'
}

describe('DynamicCards test', () => {
  it('should render the PricingCard', () => {
    render(<DynamicCard card='PricingCard' {...PricingCardProp} />)
    expect(screen.getByTestId('PricingCard-1')).toBeTruthy()
  })

  it('should render the InformationCard', () => {
    render(<DynamicCard card='InformationCard' {...InformationProp} />)
    expect(screen.getByTestId('InformationCard-1')).toBeTruthy()
  })

  it('should render the BadgeCard', () => {
    render(<DynamicCard card='BadgeCard' {...BadgeCardProp} />)
    expect(screen.getByTestId('badgecard')).toBeTruthy()
  })

  it('should render the FeaturedCard', () => {
    render(<DynamicCard card='FeaturedCard' {...FeaturedProp} />)
    expect(screen.getByTestId('featuredcard')).toBeTruthy()
  })

  it('should render the BasicCard', () => {
    render(<DynamicCard card='BasicCard' {...BasicCardProp} />)
    expect(screen.getByTestId('BasicCard-1')).toBeTruthy()
  })

  it('should render the RestaurantCard', () => {
    render(<DynamicCard card='RestaurantCard' {...RestaurantCardProp} />)
    expect(screen.getByTestId('restaurantcard')).toBeTruthy()
  })

  it('should render the ImageCard', () => {
    render(<DynamicCard card='ImageCard' {...ImageCardProp} />)
    expect(screen.getByTestId('ImageCard-1')).toBeTruthy()
  })

  it('should render the MiniCard', () => {
    render(<DynamicCard card='MiniCard' {...MiniCardProp} />)
    expect(screen.getByTestId('minicard')).toBeTruthy()
  })
})
